import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PatientTable, { PatientTableMobile } from "../components/patientTable";
import Header from "../components/header";
import AppLayout from "../components/AppLayout";
import PatientSidebarForm from "../components/PatientSidebarForm";
import { useTenant } from "../context/TenantContext";
import { useLabels } from "../utils/labels";
import {
  addBusinessPatients,
  deletePatients,
  editBusinessPatients,
  getBusinessPatients,
} from "../logic/business/action";
import {
  Box,
  Button,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
} from "@mui/material";
import { MdDownload, MdPeople, MdRefresh, MdUpload } from "react-icons/md";
import { postData } from "../utils/serverHelper";
import { PATIENTS } from "../utils/urls";
import csv from "../images/format.csv";
import iconUpload from "../images/uploadDownload.png";
import { errorMessage } from "../logic/error/action";
import InputComponents from "../components/input";

const PatientScreen = (data) => {
  const dispatch = useDispatch();
  const { tenant } = useTenant();
  const labels = useLabels();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarMode, setSidebarMode] = useState("add"); // "add" or "edit"
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [editId, setEditId] = useState(0);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [patientToDelete, setPatientToDelete] = useState(null);

  const selector = useSelector((state) => state.auth);
  const fileRef = useRef(null);

  useEffect(() => {
    getBusinessPatients(dispatch, selector?.user?.business_id);

    // Check if we should open the sidebar from URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("add") === "true") {
      setSidebarOpen(true);
      setSidebarMode("add");
      setSelectedPatient(null);
      setEditId(0);
      // Clean up URL
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [selector?.user?.business_id]);
  const selectorAuth = useSelector((state) => state.auth);
  const { user } = selectorAuth;
  const handleFormSubmit = async (values) => {
    try {
      if (sidebarMode === "add") {
        await addBusinessPatients(
          dispatch,
          selector.user.business_id,
          values,
          () => {
            // Callback after successful add - refresh is already done in addBusinessPatients
          }
        );
        // Close sidebar only after successful add
        setSidebarOpen(false);
      } else {
        await editBusinessPatients(
          dispatch,
          editId,
          values,
          selector?.user?.business_id
        );
        setSidebarOpen(false);
        getBusinessPatients(dispatch, selector?.user?.business_id);
      }
    } catch (error) {
      console.error("Error in handleFormSubmit:", error);
      // Error is already handled by the action, but we don't close the sidebar on error
      throw error; // Re-throw so formik knows submission failed
    }
  };

  const handleAddPatient = () => {
    setSelectedPatient(null);
    setSidebarMode("add");
    setSidebarOpen(true);
  };

  const handleEditPatient = (patientData) => {
    setSelectedPatient(patientData);
    setEditId(patientData?.patient_id);
    setSidebarMode("edit");
    setSidebarOpen(true);
  };

  const [fileArray, setFileArray] = useState([]);

  const onUploadFile = async (e) => {
    try {
      console.log("upload");
      if (e.target.files && e.target.files.length === 1) {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("csv", file, file.name);

        await postData(PATIENTS + "/upload/csv", formData);

        await getBusinessPatients(dispatch, selector?.user?.business_id);
        // toast.success("File uploaded successfully");
        if (fileRef.current) {
          fileRef.current.value = null;
        }
      } else {
        console.log("else vraj");
        if (fileRef.current) {
          fileRef.current.value = null;
        }
      }
    } catch (error) {
      errorMessage(
        dispatch,
        error?.response?.data?.error?.message ||
          "Server is down. Please try after some time"
      );
      console.log(error, "vraj");
      if (fileRef.current) {
        fileRef.current.value = null;
      }
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeletePatient = async (patientId) => {
    try {
      await deletePatients(dispatch, selectorAuth.user.staff_id, patientId);
      setShowConfirmationPopup(false);
      getBusinessPatients(dispatch, selector?.user?.business_id);
    } catch (error) {
      console.error("Error deleting patient:", error);
    }
  };

  // const handleSearch = (searchValue,setPage) => {
  //   // Fetch customers based on the search value
  //   getBusinessCustomers(dispatch, user.business_id, searchValue);
  //   setPage(0); // Reset the page to 0 when performing a new search
  // };
  return (
    <AppLayout>
      <PatientSidebarForm
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        mode={sidebarMode}
        patientData={selectedPatient}
        onSubmit={handleFormSubmit}
      />
      {showConfirmationPopup && (
        <div className="absolute top-[40%] left-1/2 transform -translate-x-1/2 w-[90%]  md:w-[40%]  flex flex-col z-50 bg-white text-black border-black border-[1px] pt-4 pb-4 pl-3 pr-3 rounded-lg">
          <h3 className=" text-center text-xl">
            Are you sure you want to delete this {labels.customer?.toLowerCase() || "customer"}?
          </h3>
          <div className="flex flex-row justify-center mt-5">
            <button
              className=" bg-blue-600 pl-5 pr-5 pt-2 pb-2 text-white rounded-xl"
              onClick={() => setShowConfirmationPopup(false)}
            >
              No
            </button>
            <button
              className=" bg-red-600 pl-5 pr-5 pt-2 pb-2 text-white rounded-xl ml-5  "
              onClick={() => {
                handleDeletePatient(patientToDelete);
                setShowConfirmationPopup(!showConfirmationPopup);
              }}
            >
              Yes
            </button>
          </div>
        </div>
      )}

      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          px: 3,
          pt: 1,
          pb: 3,
          gap: 1,
        }}
      >
        <Header
          title={labels.customers || "Customers"}
          middle={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton
                onClick={() => {
                  getBusinessPatients(dispatch, selector?.user?.business_id);
                }}
                sx={{
                  bgcolor: "rgba(102, 126, 234, 0.1)",
                  "&:hover": { bgcolor: "rgba(102, 126, 234, 0.2)" },
                }}
              >
                <MdRefresh />
              </IconButton>
            </Box>
          }
          actions={
            <>
              <IconButton
                onClick={handleClick}
                sx={{
                  bgcolor: "rgba(102, 126, 234, 0.1)",
                  "&:hover": { bgcolor: "rgba(102, 126, 234, 0.2)" },
                }}
              >
                <img src={iconUpload} width={24} alt="Upload" />
              </IconButton>
              <Button
                variant="contained"
                onClick={handleAddPatient}
                startIcon={<span style={{ fontSize: "1.2rem" }}>+</span>}
                sx={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "12px",
                  px: 3,
                  py: 1,
                  textTransform: "none",
                  fontWeight: 600,
                  boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)",
                    boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)",
                  },
                }}
              >
                Add {labels.customer || "Customer"}
              </Button>
            </>
          }
        />

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <label htmlFor="bulk">
            <MenuItem>
              {/* <MdDelete fontSize="small" /> */}
              <ListItemIcon>
                <MdUpload />
              </ListItemIcon>
              Upload CSV
            </MenuItem>
          </label>

          <Divider />
          <a href={csv} download={true}>
            <MenuItem onClick={() => {}}>
              <ListItemIcon>
                <MdDownload />
              </ListItemIcon>
              Download CSV format
            </MenuItem>
          </a>
          <a href={csv} download={true}>
            <MenuItem onClick={() => {}}>
              <ListItemIcon>
                <MdDownload />
              </ListItemIcon>
              Download {labels.customers || "Customer"} Data
            </MenuItem>
          </a>
        </Menu>
        <input
          type="file"
          accept=".csv"
          className="hidden"
          name="bulk"
          id="bulk"
          onChange={(e) => {
            onUploadFile(e);
          }}
        />
        <PatientTable
          setEditMode={(data) => {
            handleEditPatient(data);
          }}
          setAddMode={(data) => {
            handleEditPatient(data);
          }}
          onDeletePatient={(data) => {
            setPatientToDelete(data);
            setShowConfirmationPopup(true);
          }}
          onViewPatient={(data) => {
            handleEditPatient(data);
          }}
          onWhatsapp={(data) => {
            // setWhatsappOpen(data);
          }}
        />
        <Box sx={{ display: { xs: "block", lg: "none" } }}>
          <PatientTableMobile
            setEditMode={(data) => {
              handleEditPatient(data);
            }}
            setAddMode={(data) => {
              handleEditPatient(data);
            }}
            onDeletePatient={(data) => {
              setPatientToDelete(data);
              setShowConfirmationPopup(true);
            }}
            onViewPatient={(data) => {
              handleEditPatient(data);
            }}
          />
        </Box>
      </Box>
    </AppLayout>
  );
};

export default PatientScreen;
